import type { UseAgentVoiceReturn } from './use-agent-voice';
import { createContext, useContext } from 'react';

// Single voice handle for the whole panel. The parent <AgentPanel> mounts
// useAgentVoice once and exposes it here so descendants (the generator
// email step's mic button, the listening subtitle, future steps) reuse the
// same recorder. Two parallel useAgentVoice instances would race on the
// shared MediaRecorder/MediaStream and on the global ⌥ push-to-talk
// hotkey, so a single source of truth is required.
export const VoiceContext = createContext<UseAgentVoiceReturn | null>(null);

export function useAgentVoiceContext(): UseAgentVoiceReturn | null {
  return useContext(VoiceContext);
}
